type WayCoords = {
	center: { lat: number; lon: number }
}
type NodeCoords = {
	lat: number
	lon: number
}

export type ShortAddress = {
	latlon: [lat: number, lon: number]
	address: string
	name?: string
}

export type OverpassAddress = (WayCoords | NodeCoords) & {
	type: "node" | "way" | "relation"
	id: number
	tags: {
		"addr:city"?: string
		"addr:housenumber"?: string
		"addr:postcode"?: string
		"addr:state"?: string
		"addr:street"?: string
		name?: string
		building?: string

		[other: string]: string | undefined
	}
}

// 2. map to string
export const addressString = (x: OverpassAddress["tags"]) =>
	[
		`${x["addr:housenumber"] || ""} ${x["addr:street"] || ""}`,
		x["addr:city"],
		x["addr:state"],
		x["addr:postcode"],
		"United States",
	]
		.filter((x) => !!x)
		.join(", ")

export const coords = (x: OverpassAddress): [lat: number, lon: number] =>
	"center" in x ? [x.center.lat, x.center.lon] : [x.lat, x.lon]
